
import { defineComponent, reactive, toRefs, watch, nextTick, h, onMounted } from 'vue'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import moment from 'moment'
import globalsets from '@/utils/globalsets'
import { useRoute } from 'vue-router'
import f10ApiHk from '@/api/f10ApiHk'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    itemdata: { type: Object, default: () => ({}) },
    pageSourceData: { type: Object, default: () => ({}) },
    token: { type: String, default: '' },
  },
  setup(props) {
    const route = useRoute()
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })

    function formatNumber(value: any, type: string) {
      if (value == null) return '--'
      switch (type) {
        case 'unit': {
          const num = Number(value)
          if (Math.abs(num) >= 1e8) return '' + (num / 1e8).toFixed(2) + '亿'
          if (Math.abs(num) >= 1e4) return '' + (num / 1e4).toFixed(2) + '万'
          return '¥' + num.toFixed(2)
        }
        case 'percent':
          return Number(value) > 0 ? Number(value).toFixed(2) + '%' : Number(value).toFixed(2) + '%'
        default:
          return value
      }
    }

    pageData.columns = [
      { title: '姓名', dataIndex: 'managementName', key: 'managementName', width: '150px', align: 'left' },

      {
        title: '职务',
        dataIndex: 'seniorTriggerPositionName',
        key: 'seniorTriggerPositionName',
        width: '330px',
        ellipsis: true,
        align: 'right',
        customRender: ({ text, record }: any) => {
          return {
            children: text,
            props: {
              title: text
            }
          }
        }
      },
      {
        title: '持股占比',
        dataIndex: 'longHeldRatio',
        key: 'longHeldRatio',
        align: 'right',
        customRender: ({ text }: any) => `${text}`
      },
      { title: '薪酬(元)', dataIndex: 'annualSalary', key: 'annualSalary', align: 'right' },
      { title: '报告期', dataIndex: 'endDateOfSalary', key: 'endDateOfSalary', align: 'right' }
    ]
    function getcapitalstructure() {
      const data: any = {}
      pageData.spinning = true
      // data.data = {
      //   market: 'HK' || route.query.market,
      //   symbol: '00700' || route.query.symbol
      // }
      data.data = {
        market: route.query.market || 'HK',
        symbol: route.query.code || '00700',
      }

      data.headers = {
        token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
      }
      f10ApiHk.getBriefManagement(data).then((res: any) => {
        console.log('getBriefManagement', res.data)
        pageData.management = res.data.management
        pageData.spinning = false
      })
    }
    onMounted(() => {

      getcapitalstructure()

    })
    watch(
      () => pageData.management || [],
      (newList) => {
        const _data = newList.map((item: any) => ({
          managementName: item.managementName || '--',
          // 这里把数组拼接成字符串
          seniorTriggerPositionName: (item.seniorTriggerPositionName || []).join(', ') || '--',
          longHeldRatio: item.longHeldRatio != null ? formatNumber(item.longHeldRatio, 'percent') : '--',
          annualSalary: item.annualSalary != null ? formatNumber(item.annualSalary, 'unit') : '--',
          endDateOfSalary: item.endDateOfSalary
            ? moment(item.endDateOfSalary).format('YYYY-MM-DD')
            : '--'
        }))
        pageData.data = _data
        nextTick(() => (pageData.spinning = false))
      },
      { immediate: true, deep: true }
    )
    return { ...toRefs(pageData) }
  }
})
